import React from 'react';
import css from './ShopSettingsForm.module.css';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment';
import { Icons } from '../../../components';

const StatsSections = ({ profileCreatedAt, lastLogin, intl }) => {
  const formattedCreatedAt = moment(profileCreatedAt).format('MMMM YYYY');
  const formattedLastActive = moment(lastLogin).format('dddd, MMMM DD, YYYY');

  return (
    <div className={css.statsBox}>
      <span>
        <Icons name="time" />
        <FormattedMessage id="ShopSettingsForm.lastActivity" />
        <strong>{formattedLastActive}</strong>
      </span>
      <span>
        <Icons name="user" />
        <FormattedMessage id="ShopSettingsForm.memberSince" />
        <strong>{formattedCreatedAt}</strong>
      </span>
    </div>
  );
};

export default StatsSections;
